/**
 * Orders (spec part B, Gareth 2026-10-16).
 *
 * An order is a purchase already agreed. It moves only through the stages
 * ticked "used by orders" in Product Configuration; the API refuses any
 * other (services/stageMove.js). The stage it is on now always stays in the
 * list, so a select never loses its current value.
 */
export function stagesForLine(stages, line) {
  if (!line?.is_order) return stages || [];
  return (stages || []).filter(stage => stage.used_by_orders || stage.stage_name === line.stage);
}

/** "Accepted 16/10/2026 by Sam" / "Not accepted yet" for an order group. */
export function acceptanceLabel(group, formatWhen) {
  if (!group?.is_order) return null;
  if (!group.order_accepted_at) return 'Not accepted yet';
  const when = formatWhen ? formatWhen(group.order_accepted_at) : new Date(group.order_accepted_at).toLocaleDateString('en-GB');
  return `Accepted ${when}${group.order_accepted_by_name ? ` by ${group.order_accepted_by_name}` : ''}`;
}
